import { createRoot } from "react-dom/client";
import { ThemeProvider } from "@/providers/ThemeProvider";
import App from "./App";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <ThemeProvider defaultTheme="system" storageKey="webuild-theme">
    <App />
  </ThemeProvider>
);
